export const companyRules = state => ({ slug }) => state.rules[slug];
export const isLoaded = state => ({ slug }) => typeof state.rules[slug] !== 'undefined';
export const isFetching = state => ({ slug }) => state.fetching.indexOf(slug) !== -1;
export const isUpdating = state => ({ slug }) => state.updating.indexOf(slug) !== -1;
